export default "__VITE_ASSET__CjVmGXx3__"